<template>
  <el-select clearable :value="value" @input="updateValue" placeholder="请选择目的" @clear="updateValue(undefined)">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.targetName"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
export default {
  data () {
    return {
      list: []
    }
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      var that = this
      this.api.course.targetList({}).then(function (response) {
        if (response.data.success) {
          that.list = response.data.result
        }
      })
    },
    updateValue (val) {
      this.$emit('input', val)
    }
  },
  props: {
    value: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// TargetSelect.vue?0929b01a